import { render, staticRenderFns } from "./ModalAction.vue?vue&type=template&id=6100b4bc&"
import script from "./ModalAction.vue?vue&type=script&lang=ts&"
export * from "./ModalAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports